import { useEffect, useState } from "react";

/**
 * Lee `/subscription/landing-config` (público, sin auth) para conocer flags
 * globales que afectan la UI dentro de la app, como la visibilidad de la
 * documentación. Cachea el resultado en sessionStorage durante 5 minutos para
 * evitar peticiones repetidas en cada render.
 */
const CACHE_KEY = "menugenius_site_config";
const CACHE_TTL_MS = 5 * 60 * 1000;

export function useSiteConfig() {
  const [config, setConfig] = useState(() => {
    try {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (parsed.expiresAt > Date.now()) return parsed.value;
      }
    } catch { /* ignore */ }
    return null;
  });

  useEffect(() => {
    if (config) return;
    let cancelled = false;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/subscription/landing-config`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setConfig(data);
        try {
          sessionStorage.setItem(
            CACHE_KEY,
            JSON.stringify({ value: data, expiresAt: Date.now() + CACHE_TTL_MS }),
          );
        } catch { /* ignore */ }
      })
      .catch(() => { /* silent */ });
    return () => { cancelled = true; };
  }, [config]);

  return {
    userGuideVisible: !!config?.user_guide_visible,
    plansVisible: config?.plans_visible !== false,
    betaMessage: config?.beta_message || "",
    loaded: !!config,
  };
}
